import { render, staticRenderFns } from "./CategorySearch.vue?vue&type=template&id=50374883&"
import script from "./CategorySearch.vue?vue&type=script&lang=js&"
export * from "./CategorySearch.vue?vue&type=script&lang=js&"
import style0 from "./CategorySearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports